<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Date Range</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                            v-model="searchParams.salesDateRange"
                            type="daterange"
                            align="left"
                            start-placeholder="Start Date"
                            end-placeholder="End Date"
                            :picker-options="pickerOptions"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Territory</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.territory" filterable placeholder="Territory" clearable @change="handleTerritorySelect">
                                <el-option v-for="territory in territories"
                                           :key="territory.territory"
                                           :label="territory.territory"
                                           :value="territory.territory">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Product</p>
                    <el-form ref="product">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.product" filterable placeholder="Product" clearable @change="handleProductSelect">
                                <el-option v-for="product in products"
                                           :key="product.product"
                                           :label="product.product"
                                           :value="product.product">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Customer</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.customer" filterable placeholder="Customer" clearable @change="handleCustomerSelect">
                                <el-option v-for="customer in customers"
                                           :key="customer.customer"
                                           :label="customer.customer"
                                           :value="customer.customer">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Category</p>
                    <el-form ref="category">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.category" filterable placeholder="Category" clearable @change="handleCategorySelect">
                                <el-option v-for="category in categories"
                                           :key="category.category"
                                           :label="category.category"
                                           :value="category.category">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">&nbsp;</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-radio-group v-model="searchParams.datatype" size="mini" @input="handleDataTypeChange">
                                <el-radio-button label="Orders"></el-radio-button>
                                <el-radio-button label="Invoices"></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSalesRefresh('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "productSalesSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                territories: [],
                products: [],
                customers: [],
                categories: [],
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: 'This year',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last 6 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        created() {
            console.log('CREATED')
            const date = new Date();
            date.setDate(date.getDate() - 7)
            console.log('created date')

            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.product = '';
            this.searchParams.customer = '';
            this.searchParams.category = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams)
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED')
            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.product = '';
            this.searchParams.customer = '';
            this.searchParams.category = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams)
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSalesRefresh(searchParams) {
                this.territories.length = 0;
                this.products.length = 0;
                this.customers.length = 0;
                this.categories.length = 0;

                this.getSales('searchParams');
            },
            getSales(searchParams) {

                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        if (searchTerms.salesDateRange[0] !== null && searchTerms.salesDateRange[0].length !== undefined) {
                            if (searchTerms.salesDateRange[0].toString().includes('/')) {
                                searchTerms.salesDateRange[0] = this.convertDate(searchTerms.salesDateRange[0])
                            }
                        }

                        if (searchTerms.salesDateRange[1] !== null && searchTerms.salesDateRange[1].length !== undefined) {
                            if (searchTerms.salesDateRange[1].toString().includes('/')) {
                                searchTerms.salesDateRange[1] = this.convertDate(searchTerms.salesDateRange[1])
                            }
                        }

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var startDate = moment(searchTerms.salesDateRange[0]).format('YYYY%2FMM%2FDD'),
                            endDate = moment(searchTerms.salesDateRange[1]).format('YYYY%2FMM%2FDD'),
                            dataType = searchTerms.datatype,
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetProductSales?startDate=' + startDate + '&endDate=' + endDate + '&dataType=' + dataType;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var lookup = {},
                                result = [],
                                custNo = 0,
                                orderDate,
                                orders = response.data.productSales;

                            if (searchTerms.territory != '') {
                                var filtered = orders.filter(function(item){
                                    return item.territory == searchTerms.territory;
                                });
                                orders = filtered;
                            }

                            if (searchTerms.product != '') {
                                var filtered = orders.filter(function(item){
                                    return item.product == searchTerms.product;
                                });
                                orders = filtered;
                            }

                            if (searchTerms.customer != '') {
                                var filtered = orders.filter(function(item){
                                    return item.customer == searchTerms.customer;
                                });
                                orders = filtered;
                            }

                            if (searchTerms.category != '') {
                                var filtered = orders.filter(function(item){
                                    return item.category == searchTerms.category;
                                });
                                orders = filtered;
                            }

                            if (this.territories.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var territory = order.territory;
                                    if (territory !== "" && territory !== null) {
                                        if (!(territory in lookup)) {
                                            lookup[territory] = 1;
                                            this.territories.push({territory: territory});
                                        }
                                    }
                                }
                                this.territories.sort((a, b)=> {
                                    var a1 = a.territory.toLowerCase();
                                    var b1 = b.territory.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            if (this.products.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var product = order.product;
                                    if (product !== "" && product !== null) {
                                        if (!(product in lookup)) {
                                            lookup[product] = 1;
                                            this.products.push({product: product});
                                        }
                                    }
                                }
                                this.products.sort((a, b)=> {
                                    var a1 = a.product.toLowerCase();
                                    var b1 = b.product.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            if (this.customers.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var customer = order.customer.trim();
                                    if (customer !== "" && customer !== null) {
                                        if (!(customer in lookup)) {
                                            lookup[customer] = 1;
                                            this.customers.push({customer: customer});
                                        }
                                    }
                                }
                                this.customers.sort((a, b)=> {
                                    var a1 = a.customer.toLowerCase();
                                    var b1 = b.customer.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            if (this.categories.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var category = order.category.trim();
                                    if (category !== "" && category !== null) {
                                        if (!(category in lookup)) {
                                            lookup[category] = 1;
                                            this.categories.push({category: category});
                                        }
                                    }
                                }
                                this.categories.sort((a, b)=> {
                                    var a1 = a.category.toLowerCase();
                                    var b1 = b.category.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            for (var order, i = 0; order = orders[i++];) {
                                if (order.name == 'Direct Mail') {
                                    order.marginpercent = 1.9;
                                    order.marginpounds = (order.listprice * 0.019).toFixed(0).toString();
                                    order.costprice = order.listprice - order.marginpounds;
                                }

                                if (order.name == 'Delivery charge') {
                                    order.marginpercent = 23;
                                    order.marginpounds = (order.listprice * 0.23).toFixed(0).toString();
                                    order.costprice = order.listprice - order.marginpounds;
                                }
                            }

                            this.$parent.sales = orders;

                            if (orders.length > 0) {
                                var total_avgsellprice = 0,
                                    total_total = 0,
                                    total_quantity = 0,
                                    total_listprice = 0,
                                    total_costprice = 0,
                                    total_marginpounds = 0;
                        
                                for (var order, i = 0; order = orders[i++];) {
                                    const temp_total_avgsellprice = Number(order.avgsellprice);
                                    if (!isNaN(temp_total_avgsellprice)) {
                                        total_avgsellprice += temp_total_avgsellprice;
                                    }
                                    const temp_total_total = Number(order.total);
                                    if (!isNaN(temp_total_total)) {
                                        total_total += temp_total_total;
                                    }
                                    const temp_total_quantity = Number(order.quantity);
                                    if (!isNaN(temp_total_quantity)) {
                                        total_quantity += temp_total_quantity;
                                    }
                                    const temp_total_listprice = Number(order.listprice);
                                    if (!isNaN(temp_total_listprice)) {
                                        total_listprice += temp_total_listprice;
                                    }
                                    const temp_total_costprice = Number(order.costprice);
                                    if (!isNaN(temp_total_costprice)) {
                                        total_costprice += temp_total_costprice;
                                    }
                                    const temp_total_marginpounds = Number(order.marginpounds);
                                    if (!isNaN(temp_total_marginpounds)) {
                                        total_marginpounds += temp_total_marginpounds;
                                    }
                                }

                                this.$parent.totals = [];
                                this.$parent.totals.push({spaces:"&nbsp;", avgsellprice:total_avgsellprice, total:total_total, quantity:total_quantity, listprice:total_listprice, costprice:total_costprice, marginpounds:total_marginpounds});
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });

                            this.$parent.sales = [];
                        })
                    } else {
                        return false;
                    }
                })
            },
            handleTerritorySelect(val) {
                console.log('handleTerritorySelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.territory = val;
                this.searchParams.product = '';
                this.searchParams.customer = '';
                this.searchParams.category = '';

                this.products.length = 0;
                this.customers.length = 0;
                this.categories.length = 0;

                this.getSales('searchParams');
            },
            handleProductSelect(val) {
                console.log('handleProductSelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.product = val;
                this.searchParams.customer = '';
                this.searchParams.category = '';

                this.customers.length = 0;
                this.categories.length = 0;

                this.getSales('searchParams');
            },
            handleCustomerSelect(val) {
                console.log('handleCustomerSelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.customer = val;
                this.searchParams.category = '';

                this.categories.length = 0;

                this.getSales('searchParams');
            },
            handleCategorySelect(val) {
                console.log('handleCategorySelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.category = val;

                this.getSales('searchParams');
            },
            handleDataTypeChange(val) {
                console.log('handleDataTypeChange');
                console.log(val);
                this.searchParams.datatype = val;

                this.getSales('searchParams');
            },
            csv() {
                var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

                const fields = [
                    {label: 'Month', value: (row, field) => monthNames[row.month - 1]},
                    {label: 'Year', value: 'year'},
                    {label: 'Territory', value: 'territory'},
                    {label: 'Customer', value: 'customer'},
                    {label: 'Product', value: 'product'},
                    {label: 'Name', value: 'name'},
                    {label: 'Category', value: 'category'},
                    {label: 'Avg Sell Price', value: 'avgsellprice'},
                    {label: 'Total', value: 'total'},
                    {label: 'Quantity', value: 'quantity'},
                    {label: 'List Price', value: 'listprice'},
                    {label: 'Cost Price', value: 'costprice'},
                    {label: 'Margin (£)', value: 'marginpounds'},
                    {label: 'Margin (%)', value: (row, field) => row.marginpercent + '%'}
                ];

                this.downloadCsv(this.exportDate, fields, this.sales)
            }
        }
    };
</script>